import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import styles from "./Login.module.scss";
import { metrics } from "@/analytics/events";
export var AccessSteps = function () {
    var intl = useIntl();
    return (React.createElement("ol", { className: styles.steps },
        React.createElement("li", null,
            React.createElement(FormattedMessage, { defaultMessage: "Get an eligible edition of the game on your favorite platform. If you possess a boxed version, please redeem your digital content key (provided in box). See <a>here</a> for the list of eligible editions.", values: {
                    a: function (content) { return (React.createElement("a", { href: intl.formatMessage({
                            id: "Cx5l0i",
                            defaultMessage: "https://ubi.li/MirageEditions",
                            description: "buy_game_home",
                        }), target: "_blank", rel: "noreferrer", onClick: function () { return metrics.clickOnBuyGameHome(); } }, content)); },
                }, id: "MmW587" })),
        React.createElement("li", null,
            React.createElement(FormattedMessage, { defaultMessage: "Launch the game at least once and connect with your Ubisoft account.", id: "WQAlax" })),
        React.createElement("li", null,
            React.createElement(FormattedMessage, { defaultMessage: "Log in above with the same Ubisoft account you\u2019re playing the game with.", id: "+2ZqQZ" }))));
};
